export const FORMAT_HTML = "html";
export const FORMAT_PLAIN = "plain";
export const FORMATS = [FORMAT_HTML, FORMAT_PLAIN];
